module.exports = __webpack_public_path__ + "img/cadou_noiembrie_2023_client.69f92822.png";